import { render, staticRenderFns } from "./pointDetail.vue?vue&type=template&id=22da8e38&scoped=true&"
import script from "./pointDetail.vue?vue&type=script&lang=js&"
export * from "./pointDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da8e38",
  null
  
)

export default component.exports